// Tiny cross-scene session singleton: the (optional) wallet link and a pending
// private-room code parsed from an invite link (?room=CODE).

import type { WalletLink } from "./net";

export const session: {
  walletLink: WalletLink | null;
  pendingRoom: string | null;
} = { walletLink: null, pendingRoom: null };
